<template>
  <!--
     Vue 过滤器的演示与使用
         过滤器默认支持多参数传递
    -->
  <div class="container">
    <ul>
      <li v-for="(item, kys) in scorelist" :key="kys">
        <span>{{ item | spanshow("a", "b", "c") }}</span
        ><label>分数:{{ item }}</label>
      </li>
    </ul>
    <hr/>
    <!--
      vue 全局过滤器执行跟局部一致
    -->
    <ul>
      <li v-for="(item, kys) in scorelist" :key="kys">
        <span>{{ item | spanshow2() }}</span
        ><label>分数:{{ item }}</label>
      </li>
    </ul>
  </div>
</template>
<script>
import { Indicator, Toast } from "mint-ui";
import Vue from 'vue';//引入Vue组建-用于使用定义全局过滤器
//定义全局过滤器
Vue.filter("spanshow2", function (e) {
  var tp = Math.ceil(e);  
  var result = "";
  if (tp == 1) {
    result = "★☆☆☆☆";
  } else if (tp == 2) {
    result = "★★☆☆☆";
  } else if (tp == 3) {
    result = "★★★☆☆";
  } else if (tp == 4) {
    result = "★★★★☆";
  } else if (tp == 5) {
    result = "★★★★★";
  }
  return result;
});
export default {
  name: "ttindex3",
  data() {
    return {
      scorelist: [1.4, 2.5, 3.1, 4.5, 4.9],
    };
  },
  filters: {
    spanshow: function (e, e2, e3, e4) {
      var tp = Math.ceil(e);
      console.log("e:" + e + ",e2:" + e2 + ",e3:" + e3 + ",e4:" + e4);
      var result = "";
      if (tp == 1) {
        result = "★☆☆☆☆";
      } else if (tp == 2) {
        result = "★★☆☆☆";
      } else if (tp == 3) {
        result = "★★★☆☆";
      } else if (tp == 4) {
        result = "★★★★☆";
      } else if (tp == 5) {
        result = "★★★★★";
      }
      return result;
    },
  },
  methods: {},
};
</script>
<style scoped lang='scss'>
</style>
